<template>
    <ul class="nav navbar-nav pull-right hidden-xs">
        <a href="/auth/login#login" v-if="appear_logged_in">
            <div class="appear-logged-in mimic-title">
                <span v-html="translations['auth.no_longer_signed_in']"></span>
                <div class="user-icon">
                    <img :src="avatar">
                    <i class="fa fa-exclamation-triangle deep-shadow"></i>
                </div>
                <p>{{ name }}</p>
            </div>
        </a>
        <template v-else>
            <li class="m-l">
                <a href="/auth/login#login">{{ translations['navigation.login'] }}</a>
            </li>

            <li v-if="settings['allow_registration'] == 1 && settings['hide_registration'] == 0">
                <a href="/auth/login#register" class="btn bg-orange">{{ translations['navigation.register'] }}</a>
            </li>
        </template>
    </ul>
</template>

<script>
    import {mapState} from 'vuex';
    import Cookies from 'js-cookie'

    export default {
        computed: {
            ...mapState([
                'settings',
                'translations',
            ]),
        },

        data() {
            return {
                appear_logged_in: false,
                name: '',
                avatar: '',
            }
        },

        created() {
            let appear_logged_in_cookie = Cookies.get('has-logged-in-before');

            if(appear_logged_in_cookie !== undefined) {
                let parsed_cookie = JSON.parse(appear_logged_in_cookie);

                if(typeof parsed_cookie.avatar !== "undefined") {
                    this.name = parsed_cookie.firstname;
                    this.avatar = parsed_cookie.avatar;
                    this.appear_logged_in = true;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .appear-logged-in {
        display: flex;
        padding: 0 4px;
        height: 50px;
        align-items: center;

        .user-icon {
            position: relative;
        }

        img, p {
            opacity: 0.8;
        }

        p {
            color: #fff;
            margin: 0;
            margin-left: 10px;
            font-size: 14px;
        }

        img {
            height: 40px;
            border-radius: 100% !important;
        }

        i {
            width: 20px;
            height: 20px;
            color: darkred;
            background: #fff;
            border-radius: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            padding: 5px;
            font-size: 10px;
            right: -6px;
            top: -7px;
        }
    }

    .mimic-title {
        position: relative;

        span {
            display: none;
        }

        &:hover {
            span {
                text-align: center;
                color: #fff!important;
                display: block;
                line-height: 1.6;
                font-size: 12px;
                padding: 8px;
                background: rgba(70,70,70,.88);
                position: absolute;
                left: 50%;
                transform: translate(-50%);
                -webkit-transform: translate(-50%);
                -ms-transform: translate(-50%);
                width: auto;
                top: calc(100% + 6px);
                z-index: 2000;
                border-radius: 3px !important;
                white-space: nowrap;
                font-weight: 600;
            }
        }
    }
</style>